var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.visible,
            "close-on-click-modal": false,
            "before-close": _vm.beforeClose,
            title: _vm.title,
            "append-to-body": "",
            width: "580px",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          !_vm.showRepeat
            ? _c(
                "div",
                [
                  _c(
                    "el-form",
                    {
                      ref: "ruleForm",
                      attrs: {
                        model: _vm.form,
                        rules: _vm.rules,
                        "label-position": "left",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { prop: "title", label: "日程内容" } },
                        [
                          _c("el-input", {
                            staticStyle: { width: "430px" },
                            attrs: {
                              maxlength: "100",
                              placeholder: "请输入日程内容",
                              "show-word-limit": "",
                            },
                            model: {
                              value: _vm.form.title,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "title", $$v)
                              },
                              expression: "form.title",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "日程类型", prop: "schedule_id" } },
                        [
                          _c("div", { staticClass: "color_change" }, [
                            _c("span", {
                              staticClass: "custom_left",
                              style: { backgroundColor: _vm.colorItem },
                            }),
                          ]),
                          _vm._v(" "),
                          _c(
                            "el-select",
                            {
                              staticClass: "select_color",
                              attrs: { placeholder: "选择日程类型" },
                              model: {
                                value: _vm.form.schedule_id,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "schedule_id", $$v)
                                },
                                expression: "form.schedule_id",
                              },
                            },
                            _vm._l(_vm.cusCheck, function (item) {
                              return item.type == 2
                                ? _c(
                                    "el-option",
                                    {
                                      key: item.schedule_id,
                                      attrs: {
                                        value: item.schedule_id,
                                        label: item.name,
                                      },
                                      nativeOn: {
                                        click: function ($event) {
                                          return _vm.changeType(item)
                                        },
                                      },
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "custom_left",
                                        style: { backgroundColor: item.color },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "custom_right" },
                                        [_vm._v(_vm._s(item.name))]
                                      ),
                                    ]
                                  )
                                : _vm._e()
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "开始时间", prop: "start_time" } },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              type: "datetime",
                              "default-time": "09:00:00",
                              placeholder: "选择日期",
                            },
                            on: { change: _vm.changeStartTime },
                            model: {
                              value: _vm.form.start_time,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "start_time", $$v)
                              },
                              expression: "form.start_time",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "结束时间", prop: "end_time" } },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              "picker-options": _vm.pickerOptions,
                              type: "datetime",
                              "default-time": "09:00:00",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              placeholder: "选择日期",
                            },
                            model: {
                              value: _vm.form.end_time,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "end_time", $$v)
                              },
                              expression: "form.end_time",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "参与人员", prop: "owner_user_ids" },
                        },
                        [
                          _c("xh-user-cell", {
                            attrs: { value: _vm.checkedUser, radio: false },
                            on: { "value-change": _vm.selectUser },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.choseMore
                        ? _c(
                            "el-form-item",
                            { staticStyle: { "margin-top": "-10px" } },
                            [
                              _c(
                                "el-button",
                                {
                                  staticStyle: { "font-size": "14px" },
                                  attrs: { type: "text" },
                                  on: {
                                    click: function ($event) {
                                      _vm.choseMore = true
                                    },
                                  },
                                },
                                [_vm._v("添加更多选项")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.choseMore
                        ? [
                            _vm._l(_vm.notice, function (noticeItem, index) {
                              return [
                                _c(
                                  "el-form-item",
                                  { key: index, attrs: { label: "提前" } },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "time_select",
                                        attrs: { placeholder: "选择时间" },
                                        model: {
                                          value: _vm.notice[index].value,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.notice[index],
                                              "value",
                                              $$v
                                            )
                                          },
                                          expression: "notice[index].value",
                                        },
                                      },
                                      _vm._l(
                                        _vm.timeList[
                                          _vm.notice[index].type || 1
                                        ],
                                        function (item) {
                                          return _c("el-option", {
                                            key: item,
                                            attrs: { label: item, value: item },
                                          })
                                        }
                                      ),
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-select",
                                      {
                                        staticClass: "time_select",
                                        on: {
                                          change: function ($event) {
                                            return _vm.changeTimeType(
                                              _vm.notice[index].type,
                                              index
                                            )
                                          },
                                        },
                                        model: {
                                          value: _vm.notice[index].type,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.notice[index],
                                              "type",
                                              $$v
                                            )
                                          },
                                          expression: "notice[index].type",
                                        },
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { value: 1, label: "分钟" },
                                        }),
                                        _vm._v(" "),
                                        _c("el-option", {
                                          attrs: { value: 2, label: "小时" },
                                        }),
                                        _vm._v(" "),
                                        _c("el-option", {
                                          attrs: { value: 3, label: "天" },
                                        }),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    index != 0
                                      ? _c("el-button", {
                                          attrs: {
                                            icon: "el-icon-delete",
                                            type: "text",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.deleteNotice(index)
                                            },
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "new_notice",
                                on: { click: _vm.addNewNotice },
                              },
                              [_vm._v("+ 添加新提醒")]
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "相关信息" } },
                              [
                                _c("related-business", {
                                  attrs: {
                                    "is-task": true,
                                    "all-data": _vm.allData,
                                    "show-foot": "",
                                    "margin-left": "80px",
                                  },
                                  on: {
                                    unbind: _vm.unbindRelatedInfo,
                                    checkInfos: _vm.checkInfos,
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.choseMore
                        ? _c(
                            "el-form-item",
                            { staticStyle: { "margin-top": "-10px" } },
                            [
                              _c(
                                "el-button",
                                {
                                  staticStyle: { "font-size": "14px" },
                                  attrs: { type: "text" },
                                  on: {
                                    click: function ($event) {
                                      _vm.choseMore = false
                                    },
                                  },
                                },
                                [_vm._v("隐藏更多选项")]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                1
              )
            : _c("repeat", {
                ref: "repeat",
                attrs: {
                  detail: _vm.todayDetailData,
                  "repeat-type": _vm.form.repetitionType,
                  "margin-left": "80px",
                },
              }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { disabled: _vm.disabled, type: "primary" },
                  on: { click: _vm.sure },
                },
                [_vm._v("确 定")]
              ),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.cancle } }, [_vm._v("取 消")]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }